import { gql } from '@apollo/client'
import { ReactNode } from 'react'

import { AppbarBase } from '../../appbar-base/'
import { MotionAppbar_DocumentFragment } from './__generated__/motion-appbar.graphql'

export interface MotionAppbarProps {
  document: MotionAppbar_DocumentFragment
  className?: string
  toolbar: ReactNode
}

const VISIBLE_SUBJECTS = 20

export function MotionAppbar(props: MotionAppbarProps) {
  const { document } = props
  const { lawsuit } = document
  const caption = lawsuit?.subjects?.slice(0, VISIBLE_SUBJECTS)?.join(' · ') || ''

  return <AppbarBase {...props} title={document.title} caption={caption} />
}

MotionAppbar.fragments = {
  document: gql`
    fragment MotionAppbar_document on Document {
      title
      lawsuit {
        subjects
      }
    }
  `,
}
